import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { match } from 'react-router';
import Question from './components/question';
import SubPageController from '../components/SubPageController';
import { ROUTE_FITTING } from '../../RouteList';
import Button, { ButtonType } from '../../components/button/button';
import Image, { ImageType } from '../../components/image/image';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import './card.scss';
import DataStore from '../store/DataStore';
import { RouterStore } from 'mobx-react-router';
import messages from './messages';

interface IProps {
  dataStore?: DataStore;
  routing?: RouterStore;
  match?: match<any>;
}

interface IState {
  index: number;
  total: number;
}

class Rating extends React.Component<InjectedIntlProps & IProps, IState> {
  private subViewRoutes = [];

  constructor(props) {
    super(props);
    this.subViewRoutes = this.props.dataStore.questions.map(
      (question, index) => {
        const nextQuestion = this.props.dataStore.questions[index + 1];
        const nextSrc = nextQuestion ? nextQuestion.src : '';
        return {
          Component: Question,
          validator: () => this.props.dataStore.questionValidator(question.id),
          path: index + 1,
          props: { ...question, nextSrc }
        };
      }
    );
  }
  private onComplete = () => {
    const {
      routing: { push }
    } = this.props;
    push(ROUTE_FITTING);
  };

  public render() {
    const { match, dataStore } = this.props;

    return (
      <React.Fragment>
        <div className="c-card o-ratio o-ratio--rating u-ratio--rating">
          {dataStore.questionIndex >= 0 && dataStore.locale.startsWith('nl') && (
            <div className="c-image__bubble">
              <FormattedMessage {...messages[dataStore.questionIndex]} />
            </div>
          )}

          <SubPageController
            subViewRoutes={this.subViewRoutes}
            match={match}
            onComplete={this.onComplete}
            render={({
              index,
              total,
              currentRouteIsValid,
              handlePrev,
              handleNext
            }) => (
              <React.Fragment>
                {index != 0 && (
                  <div className="c-card__left">
                    <Button
                      type={ButtonType.circlePrev}
                      onClick={() => handlePrev()}
                    />
                  </div>
                )}
                <div className="c-card__right">
                  <Button
                    type={
                      index + 1 === total
                        ? ButtonType.circleDone
                        : ButtonType.circleNext
                    }
                    onClick={() => handleNext()}
                    disabled={!currentRouteIsValid}
                  />
                </div>
              </React.Fragment>
            )}
          />
        </div>

        <Image
          imgSrc="/images/svg/rating-holding-progress.svg"
          alt={'Progress'}
          type={ImageType.rating}
          text={dataStore.questionProgress}
        />
      </React.Fragment>
    );
  }
}

export default inject('routing', 'dataStore')(injectIntl(observer(Rating)));



// WEBPACK FOOTER //
// ./src/containers/rating/Rating.tsx